<template>
  <!-- 首页不展示面包屑 -->
  <nav v-if="!isHome" class="site-breadcrumb" aria-label="Breadcrumb">
    <ol class="site-breadcrumb__list" itemscope itemtype="https://schema.org/BreadcrumbList">
      <li
        class="site-breadcrumb__item"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <a href="/" itemprop="item">
          <span itemprop="name">Home</span>
        </a>
        <meta itemprop="position" content="1" />
      </li>
      <li
        v-if="currentLabel"
        class="site-breadcrumb__item is-current"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <span itemprop="name">{{ currentLabel }}</span>
        <meta itemprop="position" content="2" />
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  computed: {
    isHome() {
      const path = (this.$route && this.$route.path) || '';
      return path === '/' || path === '';
    },
    currentLabel() {
      const route = this.$route;
      if (!route || this.isHome) return '';
      return (route.meta && route.meta.breadcrumb) || route.meta.appname || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.site-breadcrumb {
  width: 100%;
  background: #f5f7fa;
  border-bottom: 1px solid #e8ecf1;
}

/* 与导航 .inside-navigation（width: 80%）左端对齐
   需 !important 覆盖全局 ol { margin-left: 20px !important } */
.site-breadcrumb__list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  width: 80%;
  margin: 0 auto !important;
  padding: 0.65rem 0 !important;
  list-style: none !important;
  font-size: 0.875rem;
  line-height: 1.4;
  color: #6b7280;
  box-sizing: border-box;
}

.site-breadcrumb__item {
  display: inline-flex;
  align-items: center;
  margin-bottom: 0 !important;
  padding-left: 0 !important;

  a {
    color: var(--read-link, #06c755);
    text-decoration: none;

    &:hover {
      color: var(--read-link-hover, #05a949);
      text-decoration: underline;
    }
  }

  &.is-current {
    color: #374151;
    font-weight: 500;
  }

  &:not(:last-child)::after {
    content: '/';
    margin-left: 0.35rem;
    color: #9ca3af;
  }
}
@media screen and (max-width: 768px) {
  .site-breadcrumb__list {
    width: 100%;
    padding: 0.65rem 16px;
  }
}
</style>
